export const baseUrl = "https://stgradarapi.dhwaniris.in/api/";
export const recaptchaSiteKey = "6LeRPC0sAAAAAJ7nOn986cFqLyA2SxJbiDZu5MXu";
